import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';

import { ContestQueryKeys, STALE_TIME } from '~/domains/contest/constants/query';
import { getCommissionerContestsV2 } from '~/services/contests/contests-v2.service.api';
import parseCommissionerContestsV2 from '~/domains/channel/components/ChannelContests/parseCommissionerContestsV2';

// Match the commissioner Final + restart view (the "View all" target) exactly, so the
// homepage widget and that page can't diverge. Restart eligibility is owned by the V2
// `needsRestart` flag on contests-service-v2 — the legacy V1 `needsReset` path is not used.
const RESTARTS_LIMIT = 50;

export const useGetContestsRestarts = ({ userId }: { userId: string }) => {
  const { data, isLoading, isFetching, refetch } = useQuery({
    queryKey: ContestQueryKeys.GET_CONTESTS_RESTARTS({ userId }),
    queryFn: () =>
      getCommissionerContestsV2({
        tab: 'final',
        needsRestart: 'true',
        limit: RESTARTS_LIMIT,
      }),
    staleTime: STALE_TIME,
    enabled: !!userId,
  });

  const contests = useMemo(() => parseCommissionerContestsV2(data?.data ?? []), [data?.data]);

  return {
    contests,
    totalCount: data?.total,
    isLoading,
    isFetching,
    refetch,
  };
};
